import { REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import { buildCreateCaseCallbacksPayload } from '@/utils/amend/buildCreateCaseCallbacksPayload'

export type CreateCaseCallbacksResponse = {
  mobile?: string
  type?: string
  email?: string
  header?: string
  message?: string
}

export async function postCreateCaseCallbacks(
  tripId: string,
  reqObj: Record<string, unknown>,
  context: {
    caseFlowType: string
    isFlexiFlyIntlBooking: boolean
    getSourceType: () => string
  }
): Promise<CreateCaseCallbacksResponse> {
  const payload = buildCreateCaseCallbacksPayload(reqObj, context)
  const url = `/communication/selfcare/api/createCaseCallbacks/${encodeURIComponent(tripId)}`
  return baseFetch<CreateCaseCallbacksResponse>({
    url,
    method: REQUEST_METHODS.POST,
    body: JSON.stringify(payload),
  })
}
